import { useEffect } from 'react';
import Config from '../_config/config';

/**
 * Custom hook to set the browser tab title dynamically.
 * Format: "{TenantName} | {PageTitle}"
 *
 * @param pageTitle - The title for the current page/module
 * @param deps - Optional dependency array to trigger title updates
 *
 * @example
 * // Basic usage
 * useDocumentTitle('Study Resources');
 * // Result: "TRIANGLES | Study Resources"
 *
 * @example
 * // With dynamic value
 * useDocumentTitle(`Editing ${resourceName}`, [resourceName]);
 */
export const useDocumentTitle = (pageTitle: string, deps: React.DependencyList = []) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = pageTitle
      ? `${Config.tenantDisplayName} | ${pageTitle}`
      : Config.tenantDisplayName;

    // Restore previous title on unmount (optional, can be removed if not desired)
    return () => {
      document.title = previousTitle;
    };
  }, [pageTitle, ...deps]);
};

export default useDocumentTitle;
